import api from "./api";

// Job Category service (CRUD)
// GET    /job-category
// GET    /job-category/:id
// POST   /job-category
// PATCH  /job-category/:id
// DELETE /job-category/:id

export async function getJobCategories() {
  const res = await api.get("/job-category");
  return Array.isArray(res) ? res : [];
}

export async function getJobCategoryById(categoryId) {
  if (categoryId === undefined || categoryId === null || categoryId === "") {
    throw new Error("categoryId is required");
  }
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.get(`/job-category/${idNum}`);
}

export async function createJobCategory(payload) {
  return api.post("/job-category", payload || {});
}

export async function updateJobCategory(categoryId, payload) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/job-category/${idNum}`, body);
}

export async function deleteJobCategory(categoryId) {
  const idNum = Number(categoryId);
  if (!Number.isInteger(idNum)) throw new Error("categoryId must be an integer");
  return api.delete(`/job-category/${idNum}`);
}
